app.service('ajaxOrder', function (broker, console, loading, modal, front, callback, scroll) {
	let $savedForm;
	function setForm($form) {
		$savedForm = $form;
		console.log('WYSŁANIE AJAXOWEGO FORMULARZA');
		$savedForm.ajaxForm({
			data: {
				ajax: true
			},
			beforeSubmit: function () {
				loading.start();
			},
			success: function (html) {
				success({
					html: html,
					scroll: '#operator-client-box, #login-box, #cart-retrieve, #shop-delivery .row-delivery-point:visible, #home-delivery .row-delivery-point:visible, form'
				});
			}, error: function () {
				error();
			}
		});
	}
	function sendWithoutAjax(params) {
		const redirectUrl = $(params?.html).find('meta[name="redirectUrl"]').attr('content');
		if(redirectUrl && redirectUrl.length) {
			console.log('TWARDE PRZEKIEROWANIE BEZ AJAXA');
			loading.redirect({
				href: redirectUrl,
				soft: false
			});
		} else if ($savedForm && $savedForm.length) {
			console.log('PONOWNE WYSŁANIE FORMULARZA BEZ AJAXA');
			$savedForm.ajaxFormUnbind(); 	// usuwa obsługę ajaxForm
			$savedForm.submit();			// wysyła normalnie
		} else if(params.href){
			console.log('PONOWNE TWARDE PRZEKIEROWANIE BEZ AJAXA');
			loading.redirect({
				href: params.href,
				soft: false
			});
		}else {
			console.log('Brak obsługi błędnej strony w wersji ajax');
		}
	}
	let isOneInit = false;
	function init() {
		if (!isOneInit) {
			isOneInit = true;
			window.addEventListener('popstate', function (event) {
				console.log('POPSTATE');
				const href = event.state && event.state.url ? event.state.url : location.pathname;
				if (href) {
					back(href);
				}
			});
			broker.on('SOFT_RELOAD', function () {
				if (testAB.getVar('ajax-order2') == 'B') {
					console.log('SOFT_RELOAD');
					reload();
				} else {
					loading.reload({ soft: false });
				}
			});
			broker.on('SOFT_REDIRECT', function (e, href) {
				console.log('SOFT_REDIRECT', href);
				if (href && href.length) {
					if (testAB.getVar('ajax-order2') === 'B' && front.getParam('ajaxOrder')) {
						get({
							href: href,
							scroll: '.page'
						});
					} else {
						loading.redirect({
							href: href,
							soft: false
						});
					}
				} else {
					console.log('Brak href do przekierowania')
				}
			});
		}
	}
	function success(params) {
		console.log('AJAXORDER SUCCESS', params);
		let $target = $('body > .page');
		params.oldUrl = $('meta[name="nice"]').attr('value');
		let $newHtml = $('<div>' + params.html + '</div>');
		params.wrongHtml = params.html.indexOf('app.pageConfig') == -1;
		if (params.wrongHtml) {
			console.log('WYKRYTO BŁĘDNY HTML NOWEJ STRONY');
			sendWithoutAjax(params);
			return;
		}
		let newUrl = $newHtml.find('meta[name="nice"]').attr('value');
		params.withoutExternalScripts = $newHtml.find('meta[name="withoutExternalScripts"]').attr('value') === 'true';
		let newCsrfContent = $newHtml.find('meta[name="_csrf"]').attr('content');
		let newTitle = $newHtml.find('title').text();
		let $newPage = $newHtml.find('.page');
		let result = $newPage.html();
		let newId = $newPage.attr('id');
		let newClass = $newPage.attr('class');
		params.newTitle = newTitle;
		params.newUrl = newUrl;
		params.newId = newId;
		params.newClass = newClass;
		params.token = newCsrfContent;
		if (params.newUrl && params.withoutExternalScripts) {
			console.log('Przeładowanie strony z powodu wykrycia że kolejna strona powinna być ładowana bez zewnętrznych skryptów');
			document.location.href = newUrl;
			return;
		}
		modal.removeRemodals();
		broker.trigger('BEFORE_PAGE_CHANGE');
		callback.run('beforePageChange');
		$target.html(result);
		UA.init();
		$('head title').text(newTitle);
		if (newCsrfContent && newCsrfContent.length) {
			let newCsrfHeader = $newHtml.find('meta[name="_csrf_header"]').attr('content');
			let $newCsrf = $('head meta[name="_csrf"]');
			if ($newCsrf.length) {
				$newCsrf.attr('content', newCsrfContent);
			} else {
				let $newCsrfContent = $('<meta name="_csrf"/>');
				$newCsrfContent.attr('content', newCsrfContent);
				let $newCsrfHeader = $('<meta name="_csrf_header"/>');
				$newCsrfHeader.attr('content', newCsrfHeader);
				$('head').append($newCsrfContent).append($newCsrfHeader);
			}
		}

		$target.attr({
			id: newId,
			class: newClass
		});
		if (!params.back) {
			history.pushState(params, "", newUrl);
		}
		loading.stop();
		broker.trigger('PAGE_CHANGE');
		callback.run('pageChange');
		if (params.scroll) {
			scroll.to({ $element: $(params.scroll) });
		} else {
			console.log('BRAK SCROLLA PO ZAŁADOWANIU NOWEJ STRONY');
		}
		if (params.click) {
			let $click = $(params.click);
			if ($click.length) {
				console.log('KLIKNIĘCIE ELEMENTU: ' + params.click, $click);
				$click.first().trigger('click');
			} else {
				console.log('BRAK ELEMENTU DO KLIKA: ' + params.click);
			}
		} else {
			console.log('BRAK KLIKA PO ZAŁADOWANIU NOWEJ STRONY');
		}
		broker.trigger('AFTER_PAGE_CHANGE');
		callback.run('afterPageChange');
	}
	function error() {
		modal.alert('Załadowanie strony okazało się niemożliwe. Strona zostanie przeładowana. Spróbuj ponownie', function () {
			loading.reload({ soft: false });
		});
	}
	function reload() {
		console.log('AJAX RELOAD');
		get({
			href: location.pathname
		});
	}

	function get(params) {
		console.log('ŁADOWANIE STRONY', params);
		if (params && params.href) {
			loading.start();
			$.ajax({
				url: params.href,
				success: function (html) {
					params.html = html;
					success(params);
				},
				error: function () {
					error();
				}
			});
		} else {
			console.log('BRAK DANYCH DO WŁAŚCIWEGO ZACZYTANIA STRONY');
		}
	}
	function back(href) {
		if (href) {
			console.log('BACK', href);
			get({
				href: href,
				back: true
			});
		} else {
			console.log('BACK - BRAK DANYCH');
		}
	}

	return {
		init, get, setForm, reload
	};
});
